import { formatEbvLabelPlain } from './ebvTraitExplanations';
import { compactTraitLabelFromName } from './ebvPercentileUtils';

/**
 * Compact trait name for the phone EBV trait table: the same initialism the
 * percentile graph uses, so the table and the graph below it read alike on one
 * screen — "Gestation Length (days)" is `GL` in both.
 *
 * Caret line-break markers are stripped first; without that the whole label is
 * one "word" and the initialism degrades to its first ten characters.
 *
 * Known rough edges of the convention, inherited from the graph: societies
 * whose labels are already short get initialised too ("LPI Rank%" -> "LR"), and
 * traits that share initials collide (Rib Fat and Rump Fat are both "RF"). The
 * full label is still on the cell's `title` and in the trait info popover.
 */
export function resolveEbvShortLabel(label: string | null | undefined): string {
  const full = formatEbvLabelPlain(label ?? '');
  if (!full) return '';
  return compactTraitLabelFromName(full);
}
